import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { AuthService } from '@app/core/auth/auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'register-form',
    templateUrl: './register-form.component.html'
})
export class RegisterFormComponent implements OnInit {
    formGroup: FormGroup;

    constructor(private formBuilder: FormBuilder,
        private _authService:AuthService,
        private _router: Router
        ) {}

    ngOnInit() {
        this.formGroup = this.formBuilder.group({
            firstName: [null, [Validators.required]],
            lastName: [null, [Validators.required, ]],
            email: [null, [Validators.required, Validators.email]],
            userName: [null, [Validators.required]],
            password: [null, [Validators.required, Validators.minLength(8)]],
            isAdmin: [true, [Validators.required]],
            confirmPassword: [null, [Validators.required, this.confirmationValidator]]
        });
    }

    register() {
        console.log(this.formGroup.value);
        this._authService.signUp(this.formGroup.value).subscribe(res=>{
            console.log(res);
            this._router.navigate([`login`]);
        },
        (response) => {
            // Re-enable the form
            this.formGroup.enable();

            // Reset the form
            this.resetForm()

            // // Set the alert
            // this.alert = {
            //     type: 'error',
            //     message: 'Wrong email or password',
            // };

            // // Show the alert
            // this.showAlert = true;
        })
    }

    resetForm(): void{
        this.formGroup.patchValue({
            firstName:null,
            lastName:null,
            email:null,
            userName:null,
            password:null,
            confirmPassword:null,
            });
    }

    confirmationValidator = (control: FormControl): { [s: string]: boolean } => {
        if (!control.value) {
            return { required: true };
        } else if (control.value !== this.formGroup.controls.password.value) {
            return { confirm: true, error: true };
        }
        return {};
    };
}
